import React, { useState } from "react";
import "./rentCard.scss";
import * as conf from "../../../config";
import noPhoto from "../../images/key.svg";
import { useStoreActions, useStoreState } from "easy-peasy";
import { getAddress } from "../../utils/helper";
import { ReactSVG } from "react-svg";

const mainClass = "rentCard";

const RentCard = ({ elem, style, index }) => {
  const rentIndex = useStoreState((state) => state.rent.index);
  const setIndex = useStoreActions((actions) => actions.rent.setIndex);
  return (
    <div
      className={index == rentIndex ? `${mainClass} activeRent` : mainClass}
      style={style}
      onMouseOver={() => setIndex(index)}
      onMouseOut={() => setIndex(null)}
    >
      {elem.media[0] && (
        <div
          className={mainClass + "-pic"}
          style={{
            backgroundImage: `url(${conf.API_HOST + elem.media[0].url})`,
            backgroundSize: "cover",
          }}
        ></div>
      )}
      {!elem.media[0] && (
        <ReactSVG
          className={`${mainClass}-pic ${mainClass}-svgIcon`}
          src={noPhoto}
        />
      )}
      <div className={mainClass + "-info"}>
        <span className={mainClass + "-title"}>{getAddress(elem.map)}</span>
        <span className={mainClass + "-price"}>{elem.price} руб</span>
        <span className={mainClass + "-adress"}>{elem.area} м2</span>
      </div>
    </div>
  );
};

export default RentCard;
